<template>
<!-- 选对咨询订单支付 -->
  <div v-if="bodyShow" class="pay">
      <div class="box-card">
          <div class="head">
              <div class="bdl"></div>服务信息
          </div>
          <!-- 是否是咨询师生成的咨询方案 -->
          <template v-if="$route.query.eid && $route.query.product_name == '商品B-2次'">
            <!-- 包含项目 -->
            <div class="title-small">
                包含项目
            </div>
            <!--  -->
            <div :class="['scheme-row',item.name && item.name=='服务次数'?'on':'']" v-for="(item,index) in list" :key="index">
                <template v-if="item.name=='服务次数'">
                    <div class="frequency">
                        <label class="on" for="">{{item.name}}</label>
                        <!-- <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/xd-close-on.png" alt=""> -->
                        <span class="on"  >共{{item.val}}次</span>
                    </div>
                </template>
                <template v-else>
                    <label for="">{{item.name}}</label>
                    <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/xd-close.png" alt="">
                    <span>{{item.val}}</span>
                </template>
            </div>
          </template>
          <!--  -->
          <template v-else>
            <div class="row">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/icon1.png" alt="">
                <div class="text text-ellipsis">普通咨询（约90分钟）</div>
                <span class="right">x 1</span>
            </div>
            <div class="row">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/icon2.png" alt="">
                <div class="text text-ellipsis">定制专业测评一份</div>
                <span class="right">x 1</span>
            </div>
            <div class="row">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/icon3.png" alt="">
                <div class="text text-ellipsis">精美报告一份</div>
                <span class="right">x 1</span>
            </div>
          </template>
          <!-- 是否是咨询师生成的咨询方案 -->
          <div v-if="$route.query.eid && $route.query.product_name == '商品B-2次'" class="price-row">
              小计：<span>¥{{itemOrder.price/100}}</span>
          </div>
          <!--  -->
          <div v-else class="price-row">
              小计：<span>¥{{product_info.original_price/100}}</span>
          </div>
      </div>
      <!--  -->
      <div class="box-card">
          <div class="head">
              <div class="bdl"></div>填写个人信息
          </div>
          <div class="row-form">
              <label for="">姓名</label>
              <input type="text" v-model="name" placeholder="请填写真实姓名" />
          </div>
          <div class="row-form">
              <label for="">手机号</label>
              <input type="text" v-model="phone" placeholder="请填写手机号码" />
          </div>
      </div>
      <!-- footer -->
      <div class="footer">
          <div @click="agreement=!agreement" class="agreement">
              <img v-if="agreement" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/check-on.png" alt="">
              <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/check.png" alt="">
              我已阅读并同意新精英<span>《知情通知书》</span>
          </div>
         <!-- 是否是咨询师生成的咨询方案 -->
          <div v-if="$route.query.eid && $route.query.product_name == '商品B-2次'" class="pay-price">
              <span class="ft1">应付款：</span>
              <span class="ft2">¥{{itemOrder.price/100}}</span>
              <span class="ft3">已优惠<span>¥{{(priceOld-itemOrder.price)/100}}</span></span>
              <button class="btn" @click="createOrderPay()">立即支付</button>
          </div>
          <!--  -->
          <div v-else class="pay-price">
              <span class="ft1">应付款：</span>
              <span class="ft2">¥{{product_info.price/100}}</span>
              <span class="ft3">已优惠<span>¥{{(product_info.original_price-product_info.price)/100}}</span></span>
              <button class="btn" @click="createOrderPay()">立即支付</button>
          </div>
      </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { createOrder,saveInfo,productAll,cancelOrder,extensionGet } from "@/api/xuandui_gadgets"
import { phoneValidation } from "@u/validation";
import wx from "weixin-js-sdk";
export default {
    data(){
        return{
            bodyShow:false,
            name:'',
            phone:null,
            agreement:false,
            product_info:{},
            // 咨询方案-扩展
            list:[],
            itemOrder:{},
            priceOld:null
        }
    },
    methods:{
        // 创建订单并支付
        createOrderPay(){
             if(!this.name || !this.phone){
                this.$toast('姓名和手机号不能为空！');
                return
            }else if(!phoneValidation(this.phone)){
                this.$toast('手机号不正确！');
                return
            }else if(!this.agreement){
                this.$toast('请先同意知情同意书');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"创建订单中...");
            let q = this.$route.query;
            let obj = {
                product_id:this.product_info.id
            };
            if(q.eid && q.product_name == '商品B-2次'){
                obj['extension_id'] = this.$route.query.eid;
            }
            createOrder(obj).then((data)=>{
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                
                saveInfo({
                    order_id:data.order_id,
                    name:this.name,
                    phone:this.phone
                }).then((d2)=>{
                    if(d2.error>0){
                        this.$toast(d2.detail);
                        return
                    }
                    this.d2 = d2.item;
                    let dd = JSON.stringify(data.params);
                    let data_ = eval("(" + dd + ")");
                    let jsApiCall = () => {
                        WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
                            //关闭加载中
                            this.$emit('loadingHandle',false);
                            WeixinJSBridge.log(rest.err_msg);
                            if (rest.err_msg == "get_brand_wcpay_request:ok") {
                                this.payModelShow = false;
                                
                                this.$toast({
                                    message:'支付成功',
                                    onClose:()=>{
                                        this.$router.push({
                                            path:'/xd_pay_succ',
                                            query:{
                                                oid:data.order_id
                                            }
                                        });
                                    }
                                });
                            } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                                cancelOrder({
                                    order_id:data.order_id
                                }).then();
                                alert("支付取消");
                            } else {
                                cancelOrder({
                                    order_id:data.order_id
                                }).then();
                                alert("支付失败");
                            }
                        });
                    };

                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
                        } else if (document.attachEvent) {
                            document.attachEvent("WeixinJSBridgeReady", jsApiCall);
                            document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
                        }
                    } else {
                        jsApiCall();
                    }
                });
            });
        },
        // 初始化获取数据
        pullData(){
            document.title = '订单支付';
            //调用加载中
            this.$emit("loadingHandle", true, "获取方案信息中...");
            let q = this.$route.query;
            if(q.eid && q.product_name == '商品B-2次'){
                extensionGet({
                    id:q.eid
                }).then((data)=>{
                    //关闭加载中
                    this.$emit("loadingHandle", false);
                    if(data.error>0){
                        this.$toast(data.msg);
                        return
                    }
                    this.itemOrder = data.item;
                    if(data.item.detail && JSON.parse(data.item.detail)){
                        let obj = JSON.parse(data.item.detail);
                        let keys = Object.keys(JSON.parse(data.item.detail));
                        let array = [];
                        keys.map(v=>{
                            if(v=='服务次数'){
                                // 两次咨询九折,计算打折前价格
                                if(obj[v]==2){
                                    this.priceOld = this.itemOrder.price / 0.9;
                                }
                                // 三次咨询八折,计算打折前价格
                                if(obj[v]==3){
                                    this.priceOld = this.itemOrder.price / 0.8;
                                }
                            }
                            array.push({
                                name:v,
                                val:obj[v]
                            });
                            
                        });
                        
                        this.list = array;
                    }

                });
            }
            // 获取所有商品
            productAll({
                category_id:2,  //做自己节传1,选对小工具传2
                status:1  // 1上架  2下架
            }).then((data)=>{
                //关闭加载中
                this.$emit("loadingHandle", false);
                if(data.error>0){
                    this.$toast(data.detail);
                    return
                }
                let bool = false;
                data.list.map((v,index)=>{
                    if(v.name===q.product_name){
                        bool = true;
                        this.product_info = v;
                    }
                });
                if(!bool){
                    this.$toast('商品信息获取失败！');
                    return
                }
            })
            
            this.bodyShow = true;
            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #F7F8F9;
    }
</style>
<style lang="scss" scoped>
.pay{
    display: flex;
    flex-direction: column;
    padding: 20px 30px 192px;
    .box-card{
        background: #FFFFFF;
        border-radius: 20px;
        overflow: hidden;
        margin-bottom: 20px;
        padding-bottom: 30px;
        &:last-of-type{
            margin-bottom: 0;
        }
        .head{
            display: flex;
            align-items: center;
            font-size: 32px;
            font-weight: 600;
            color: #2B333A;
            height: 98px;
            margin-top: 10px;
            padding: 0 30px;
            .bdl{
                width: 6px;
                height: 30px;
                background: #46A3FA;
                border-radius: 6px;
                margin-right: 20px;
            }
        }
        .row{
            display: flex;
            align-items: center;
            font-size: 28px;
            font-weight: 400;
            color: #7D8289;
            height: 98px;
            padding: 0 30px 0 26px;
            img{
                width: 40px;
                height: 40px;
                margin-right: 4px;
            }
            .text{
                width: 500px;
            }
            .right{
                margin-left: auto;
            }
        }
        .title-small{
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2B333A;
            line-height: 40px;
            padding: 0 30px;
            margin-bottom: 10px;
        }
        .scheme-row{
            display: flex;
            align-items: center;
            height: 44px;
            padding: 0 30px;
            margin-bottom: 10px;
            label{
                margin-right: auto;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #7D8289;
                line-height: 44px;
            }
            img{
                width: 24px;
            }
            span{
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #7C828A;
                line-height: 40px;
            }
            .frequency{
                flex: 1;
                display: flex;
                align-items: center;
                padding-top: 22px;
                label.on{
                    margin-right: auto;
                    font-size: 28px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #2B333A;
                    line-height: 40px;
                }
                img{
                    width: 24px;
                }
                span.on{
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #7D8289;
                    line-height: 44px;
                }
            }
        }
        .scheme-row.on{
            height: auto;
            margin-bottom: 0;
        }
        .price-row{
            text-align: right;
            font-size: 28px;
            font-weight: 500;
            color: #2B333A;
            line-height: 42px;
            padding: 0 30px;
            margin-top: 30px;
            span{
                color: #FF4223;
                font-weight: bold;
            }
        }
        .row-form{
            display: flex;
            align-items: center;
            height: 98px;
            padding: 0 30px;
            label{
                font-size: 30px;
                font-weight: 500;
                color: #2B333A;
                line-height: 46px;
                width: 90px;
                margin-right: 60px;
            }
            input{
                border: none;
                font-size: 28px;
            }
        }
    }
    .footer{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        width: 100%;
        max-width: 750px;
        background-color: #FFFFFF;
        .agreement{
            display: flex;
            align-items: center;
            font-size: 24px;
            font-weight: 400;
            color: #606060;
            background-color: #FFF2E1;
            height: 72px;
            padding: 0 20px;
            img{
                width: 40px;
                height: 40px;
                margin-right: 12px;
            }
            span{
                color: #DB3843;
            }
        }
        .pay-price{
            display: flex;
            align-items: center;
            height: 120px;
            padding: 0 40px 0 20px;
            .ft1{
                font-size: 30px;
                font-weight: 500;
                color: #2B333A;
            }
            .ft2{
                font-size: 36px;
                font-weight: bold;
                color: #FF2300;
            }
            .ft3{
                margin-left: 10px;
                margin-right: auto;
                font-size: 24px;
                font-weight: 500;
                color: #A9AFB3;
                span{
                    color:#FF2300 ;
                    font-weight: bold;
                }
            }
            .btn{
                width: 200px;
                line-height: 80px;
                background: #FF4326;
                border-radius: 40px;
                font-size: 32px;
                text-align: center;
                border: none;
                outline: none;
                font-weight: 500;
                color: #FFFFFF;   
                letter-spacing: 1px;
            }
        }
    }
}
</style>